module.exports = __webpack_public_path__ + "static/images/xiaobai.3dbb5e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/openPlatform/xiaobai.png
// module id = vjTL
// module chunks = 1